import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FondeadoresService } from '../../services/fondeadores.service';
import { HelpersService } from '../../services/tools/helpers.service';
import {Location} from '@angular/common';
import { SocioFondeadorService } from '../../services/socio-fondeador.service';
import { MatDialog } from '@angular/material';
import { RechazarRetiroModalComponent } from '../../components/tools/modals/rechazar-retiro-modal/rechazar-retiro-modal.component';
import { AceptarRetiroModalComponent } from '../../components/tools/modals/aceptar-retiro-modal/aceptar-retiro-modal.component';

@Component({
  selector: 'app-perfil-socio-fondeador',
  templateUrl: './perfil-socio-fondeador.component.html',
  styleUrls: ['./perfil-socio-fondeador.component.scss']
})
export class PerfilSocioFondeadorComponent implements OnInit {

  public isLoading: boolean = false;
  public fondeadorID : number = 0;
  public fondeador : any = {};
  public retiro_saldo : any [];
  public incremento_saldo : any [];
  public isBanco : boolean = false;
  public esTarjeta: boolean = false;
  public esCLABE: boolean = false;
  public tieneRetiros: boolean = false;
  public tieneIncrementos: boolean = false;
  public total_inversiones: number = 0;
  //Login del fondeador
  public isLoginFondeador: boolean = false;
  public isLoginEjecutivoFondeador: boolean = false;

  constructor(
    public location : Location,
    private fondeadoresService: FondeadoresService,
    public socioFondeadorService: SocioFondeadorService,
    private activatedRoute : ActivatedRoute,
    private helperService : HelpersService,
    private router : Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.fondeadorID = this.activatedRoute.snapshot.params.idSocio;

    //Verificamos que no sea un login de Fondeador
    var userFondeador= localStorage.getItem("Ejecutivo_fondeador");
    if(userFondeador != null){
      var datosTemp = JSON.parse(userFondeador);
      this.isLoginEjecutivoFondeador = datosTemp.isEjecutivoFondeador;
      console.log("LoginEF: ", this.isLoginEjecutivoFondeador);
    }

    this.obtSocioId(this.fondeadorID);
    this.getRetirosSaldo(this.fondeadorID);
    this.getIncrementosSaldo(this.fondeadorID);
  }

  public obtSocioId(id:number){
    this.isLoading = true;
    this.socioFondeadorService.getSocioById(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.fondeador = jsonResult.content;
          console.log("Socio ID: ", this.fondeador);
          if(this.fondeador.deposito_fondos === "transferencia"){
            this.isBanco = true;
            if(this.fondeador.tipo_clabe_tarjeta === "tarjeta"){
              this.esTarjeta = true;
            }else if(this.fondeador.tipo_clabe_tarjeta === "clabe"){
              this.esCLABE = true;
            }else{
              this.esTarjeta = false;
              this.esCLABE = false;
            }
          }else{
            this.isBanco = false;
            this.esTarjeta = false;
            this.esCLABE = false;
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public getRetirosSaldo(id){
    this.isLoading = true;
    this.socioFondeadorService.getRetirosSaldoId(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.retiro_saldo = jsonResult.content;
         
          if(this.retiro_saldo.length > 0){
            this.tieneRetiros = true;
            console.log("RetirosSaldo: ", this.retiro_saldo);
            
          }else{
            this.tieneRetiros = false;
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public getIncrementosSaldo(id){
    this.isLoading = true;
    this.socioFondeadorService.getIncrementosSaldoId(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.incremento_saldo = jsonResult.content;
         
          if(this.incremento_saldo.length > 0){
            this.tieneIncrementos = true;
            console.log("incremento_saldo: ", this.incremento_saldo);
            
          }else{
            this.tieneIncrementos = false;
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public aceptarRetiro(id:  number, es_ingreso: any = false){
    const dialogRef = this.dialog.open(AceptarRetiroModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {idRetiro: id, ingreso:es_ingreso}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.retiro){
        this.obtSocioId(this.fondeadorID);
        this.getRetirosSaldo(this.fondeadorID);
        this.getIncrementosSaldo(this.fondeadorID);
      }
    });
  }

  public rechazarRetiro(id:  number){
    const dialogRef = this.dialog.open(RechazarRetiroModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {idRetiro: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.rechazar){
        this.obtSocioId(this.fondeadorID);
        this.getRetirosSaldo(this.fondeadorID);
        this.getIncrementosSaldo(this.fondeadorID);
      }
    });

  }

  public agregarEstiloInactivo(index: number){
    if(this.retiro_saldo[index].estatus){
      return "color-inactivo"
    }else{
      return "color-activo"
    }
  }

  public agregarEstiloInactivo2(index: number){
    if(this.incremento_saldo[index].estatus){
      return "color-inactivo"
    }else{
      return "color-activo"
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modulo-vista/perfil-socio-fondeador/perfil-socio-fondeador.component.ts